import logoMongoDB from 'assets/logos/mongodb.svg'
import logoMySQL from 'assets/logos/mysql.svg'
import logoCassandra from 'assets/logos/cassandra.svg'
import logoPostgreSQL from 'assets/logos/postgresql.svg'
import logoGCDatastore from 'assets/logos/google-cloud-datastore.svg'
import logoOracle from 'assets/logos/oracle.svg'
import logoGCPlatform from 'assets/logos/google-cloud-platform.svg'
import logoKafka from 'assets/logos/kafka.svg'
import logoActiveMQ from 'assets/logos/activemq.svg'
import logoRabbitMQ from 'assets/logos/rabbitmq.svg'
import logoGCStackdriver from 'assets/logos/google-cloud-stackdriver.svg'
import logoGrafana from 'assets/logos/grafana.svg'
import logoPrometheus from 'assets/logos/prometheus.svg'
import logoSignalFx from 'assets/logos/signalfx.svg'
import logoGCK8sEngine from 'assets/logos/google-cloud-platform-k8s-engine.svg'
import logoOpenShift from 'assets/logos/openshift.svg'
import SvgPrivateCloud from 'components/icons/PrivateCloud'
import logoDatadog from 'assets/logos/datadog.svg'
import logoAWS from 'assets/logos/aws.svg'
import logoNewRelic from 'assets/logos/newrelic.svg'
import logoKubernetes from 'assets/logos/kubernetes.svg'
import logoAzure from 'assets/logos/azure.svg'
import logoAmazonSQS from 'assets/logos/amazon-sqs.svg'
import logoAmazonECS from 'assets/logos/amazon-ecs.svg'
import logoAmazonEKS from 'assets/logos/amazon-eks.svg'
import logoAWSCloudwatch from 'assets/logos/aws-cloudwatch.svg'
import logoAmazonDynamoDB from 'assets/logos/aws-dynamodb.svg'
import SvgCloudMigration from 'components/icons/CloudMigration'

export const TECH_READINESS_RELEASE_DATE = '2020-08-13T07:00:00.000Z'

export const TECH_READINESS_CATEGORIES = {
  databases: {
    label: 'Database(s)',
    values: {
      DynamoDb: {
        logo: logoAmazonDynamoDB
      },
      MongoDb: {
        logo: logoMongoDB
      },
      MySQL: {
        logo: logoMySQL
      },
      Cassandra: {
        logo: logoCassandra
      },
      'GCP Datastore': {
        logo: logoGCDatastore
      },
      Postgres: {
        logo: logoPostgreSQL
      }
    }
  },
  cloudProvider: {
    label: 'Cloud Compute',
    values: {
      'Amazon Web Services': {
        logo: logoAWS
      },
      'Microsoft Azure': {
        logo: logoAzure
      },
      'Google Cloud Platform': {
        logo: logoGCPlatform
      },
      Oracle: {
        logo: logoOracle
      },
      'Private Cloud (On Premises)': {
        logo: SvgPrivateCloud,
        isSvgLogo: true
      },
      'Migrating Between Cloud Providers': {
        logo: SvgCloudMigration,
        isSvgLogo: true
      }
    }
  },
  messaging: {
    label: 'Messaging',
    values: {
      Kafka: {
        logo: logoKafka
      },
      ActiveMQ: {
        logo: logoActiveMQ
      },
      RabbitMQ: {
        logo: logoRabbitMQ
      },
      'AWS SQS': {
        logo: logoAmazonSQS
      }
    }
  },
  containers: {
    label: 'Container Orchestration',
    values: {
      'Amazon Elastic Kubernetes Service': {
        logo: logoAmazonEKS
      },
      'Amazon Elastic Container Service': {
        logo: logoAmazonECS
      },
      'Google Kubernetes Engine': {
        logo: logoGCK8sEngine
      },
      OpenShift: {
        logo: logoOpenShift
      },
      'Custom Kubernetes': {
        logo: logoKubernetes
      }
    }
  },
  monitoring: {
    label: 'Monitoring',
    values: {
      'Amazon CloudWatch': {
        logo: logoAWSCloudwatch
      },
      Datadog: {
        logo: logoDatadog
      },
      'Google Operations (StackDriver)': {
        logo: logoGCStackdriver
      },
      Grafana: {
        logo: logoGrafana
      },
      'New Relic': {
        logo: logoNewRelic
      },
      Prometheus: {
        logo: logoPrometheus
      },
      SignalFX: {
        logo: logoSignalFx
      },
      'Custom StatsD': {
        logo: ''
      }
    }
  }
}

export function getOrderedCategoriesFromPrompts(prompts) {
  return (
    // order them how we have them here
    Object.keys(TECH_READINESS_CATEGORIES)
      .map(key => {
        // find the matching prompt for each, and then append our fields to it
        const record = prompts.find(prompt => prompt.field === key)
        if (!record) return record
        return { ...record, ...TECH_READINESS_CATEGORIES[record.field] }
      })
      // remove any empty values (if there were old fields that don't match)
      .filter(Boolean)
  )
}
